export default {
  enabled: window.Chime.config.NODE_ENV === 'production',
  accessToken: window.Chime.config.ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    client: {
      javascript: {
        codeVersion: window.Chime.config.GIT_COMMIT_SHA,
        source_map_enabled: true,
      },
    },
    environment: window.Chime.config.DEPLOYMENT_ENVIRONMENT,
  },
  hostSafeList: ['chime.com', 'chimebank.com', '1debit.com', 'chm.life'],
  reportLevel: 'error',
  autoInstrument: {
    dom: false,
  },
};
